import { TagChip } from 'application/Shared/Components/Tag/TagChip';

/*  React  */
import React from 'react';

export const TagChipCell = (props) => {
    const { row } = props;
    const { name, color, defaultColor } = row.original;

    return <TagChip name={name} color={color || defaultColor} />;
};
